import { render, staticRenderFns } from "./SattlementOfDate.vue?vue&type=template&id=0c40f3a6"
import script from "./SattlementOfDate.vue?vue&type=script&lang=js"
export * from "./SattlementOfDate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports